import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { MplusLimit } from 'widgets/mplus/mplus-payment/ui/components/components/mplus-limit'
import {
  MplusPopUps,
  MplusPopUpsTypes,
} from 'widgets/mplus/mplus-payment/ui/components/mplus-active'
import { MplusDetail } from 'widgets/mplus/mplus-payment/ui/components/mplus-active/components/mplus-detail'
import { SelectPaymentDate } from 'widgets/mplus/mplus-payment/ui/components/mplus-active/components/select-payment-date'

import { CalculatedMplusInfo } from 'entities/mplus/module'
import { MplusPopup } from 'entities/mplus/ui/mplus-popup'

import { priceShow } from 'shared/lib/priceShow'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { LimitExceededPopup } from '../limit-exceeded-popup'
import { StatusNotice } from '../status-notice'

import s from './styles.module.scss'

interface Props {
  hasLimit: boolean
  limit?: string
  countPassengers: number
  calculatedInfo?: CalculatedMplusInfo
  paymentDay?: number
  onChangePaymentDay: (day: number) => void
}

export const MplusDetails: FC<Props> = ({
  hasLimit,
  limit,
  countPassengers,
  calculatedInfo,
  paymentDay,
  onChangePaymentDay,
}) => {
  const { t } = useTranslation()

  const { openDialog, closeDialog } = useDialogBottomSheet()

  const showPopUpInfo = (typeInfo: MplusPopUpsTypes) => {
    const { title, description } = MplusPopUps[typeInfo]

    openDialog({
      child: (
        <MplusPopup
          title={t(title)}
          description={t(description, {
            price: priceShow(String(calculatedInfo?.monthly_amount)),
          })}
        />
      ),
      isDialog: false,
    })
  }

  const showLimitExceeded = () => {
    openDialog({
      child: <LimitExceededPopup onClose={closeDialog} />,
      isDialog: false,
      borderRadius: 20,
      padding: [20],
    })
  }

  return (
    <div className={s.container}>
      {!hasLimit && (
        <StatusNotice
          variant="danger"
          title={t('mplus.limit_exceeded')}
          description={priceShow(limit || '0')}
          actionText={t('mplus.how_is_that')}
          onAction={showLimitExceeded}
        />
      )}

      {hasLimit && (
        <>
          <MplusLimit
            hasLimit
            limit={limit || '0'}
            onShowDetail={() => showPopUpInfo(MplusPopUps.availableInfo.key)}
          />

          <MplusDetail
            countPassengers={countPassengers}
            creditMoneyEachMonth={calculatedInfo?.monthly_amount}
            eachPassengerPayInfo={calculatedInfo?.monthly_amount_per_passenger}
            showPayInfo={() => showPopUpInfo(MplusPopUps.eachMonthPayInfo.key)}
            showCashbackInfo={() => showPopUpInfo(MplusPopUps.cashback.key)}
          />

          <SelectPaymentDate
            currentDate={paymentDay}
            onChange={onChangePaymentDay}
            onShowDetailPaymentDays={() =>
              showPopUpInfo(MplusPopUps.witchDayPayInfo.key)
            }
          />
        </>
      )}
    </div>
  )
}
